var APP = {} // eslint-disable-line

import { include } from './bundler'
import { logger } from './logger'
import { copy } from './copy'
import './polyfills'

Object.defineProperty(utils, 'app', {
  get: () => APP,
  set: (val) => { APP = val }
})

const cssProps = {
  init: () => setTimeout(global.cssVarPoly.init, 450),
  refresh: () => setTimeout(() => {
    global.cssVarPoly.findCSS()
    global.cssVarPoly.updateCSS()
  }, 450)
}

export { include, logger, copy, cssProps }



// WEBPACK FOOTER //
// ./src/core/utils/index.js